// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"182":"06a33ebc","1373":"4fbac667","3040":"43e9a5fe","3628":"06a33ebc","7350":"36d9e990","7396":"43e9a5fe"}[chunkId] + ".chunk.css";
};